<template>
  <form class="eligibility-tool__question" @submit.prevent="submitAnswer" novalidate>
    <h2
      :id="headingId"
      ref="screenHeading"
      class="eligibility-tool__heading"
      tabindex="-1"
      data-modal-heading
    >{{ question.title }}</h2>
    <p v-if="question.helper" class="eligibility-tool__helper">{{ question.helper }}</p>

    <ul v-if="question.links && question.links.length" class="eligibility-tool__programme-list">
      <li v-for="link in question.links" :key="link.text"><a :id="`contextual-offers-programme-link-${sanitizeId(link.text)}`" :href="link.url" target="_blank" rel="noopener noreferrer">{{ link.text }}</a></li>
    </ul>

    <p v-if="error" class="eligibility-tool__error" role="alert">{{ question.error }}</p>

    <fieldset class="eligibility-tool__fieldset">
      <legend class="sr-only">{{ question.title }}</legend>
      <label
        v-for="option in question.options"
        :key="option.value"
        class="eligibility-tool__radio-option form-control"
        :for="`contextual-offers-${question.id.toLowerCase()}-${option.value}-radio`"
      >
        <input
          :id="`contextual-offers-${question.id.toLowerCase()}-${option.value}-radio`"
          v-model="selected"
          class="eligibility-tool__radio"
          type="radio"
          :name="question.answerKey"
          :value="option.value"
          :aria-label="option.label"
          @change="error = false"
        />
        <span class="eligibility-tool__radio-label">{{ option.label }}</span>
      </label>
    </fieldset>

    <div class="eligibility-tool__actions button-group">
      <button
  :id="`contextual-offers-${question.id.toLowerCase()}-next-button`"
  class="button bg-bright-red eligibility-tool__button eligibility-tool__button--primary"
  type="submit"
>
  {{ question.id === 'Q6' ? 'Check results' : 'Next' }}
</button>
      <button :id="`contextual-offers-${question.id.toLowerCase()}-back-button`" class="button button--outline eligibility-tool__button eligibility-tool__button--secondary" type="button" @click="$emit('back')">Back</button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RadioQuestion',
  props: { question: { type: Object, required: true } },
  data() { return { selected: '', error: false }; },
  computed: {
    ...mapState(['answers']),
    headingId() { return this.question.id === 'Q1' ? 'contextual-offers-dialog-title' : `contextual-offers-${this.question.id.toLowerCase()}-heading`; }
  },
  watch: {
    question: {
      immediate: true,
      handler(question) {
        this.selected = this.answers[question.answerKey] || '';
        this.error = false;
        this.focusHeading();
      }
    }
  },
  mounted() { this.focusHeading(); },
  methods: {
    focusHeading() {
      this.$nextTick(() => {
        const modalContent = this.$el.closest('.eligibility-tool__modal-content');
        if (modalContent) modalContent.scrollTo({ top: 0, left: 0 });
        if (this.$refs.screenHeading) this.$refs.screenHeading.focus({ preventScroll: true });
      });
    },
    sanitizeId(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); },
    submitAnswer() {
      if (!this.selected) { this.error = true; return; }
      this.error = false;
      this.$emit('answer', { key: this.question.answerKey, value: this.selected });
    }
  }
};
</script>
